import React from 'react';
import moment from 'moment';
import { withRouter } from 'react-router-dom'
import { isEmpty } from 'lodash'
import { i18n } from '../../../../../translate/i18n';
import { Container } from './card.style'
import numberToCurrency from '../../../../../utils/numberToCurrency'

const MaintenanceCard = props => {
  const maintenance = props.data;
  const goToMaintenance = (maintenanceId, equipId) => {
    props.history.push(`/form-maintenance/${maintenanceId}/${equipId}`)
  }

  let showInCalendarAsScheduledInGreen = false;
  // if(props.payload?.showInCalendarAsScheduledInGreen === true) {
  //   showInCalendarAsScheduledInGreen = true;
  // } else {
  //   showInCalendarAsScheduledInGreen = false;
  // }

  let showInCalendarAsInProgressInGreen = false;
  // if(props.payload?.showInCalendarAsInProgressInGreen === true) {
  //   showInCalendarAsInProgressInGreen = true;
  // } else {
  //   showInCalendarAsInProgressInGreen = false;
  // }

  return (
    <Container style={ styles.container } stage={props.stage} showInCalendarAsScheduledInGreen={showInCalendarAsScheduledInGreen} showInCalendarAsInProgressInGreen={showInCalendarAsInProgressInGreen} onClick={() => goToMaintenance(maintenance._id, maintenance.equipment._id)}>
      {/* <div style={styles.titleContainer}>
        <div style={styles.equipmentName}>{maintenance.description}</div>
      </div> */}
      <div style={styles.maintenanceContainer}>
        <div style={styles.label}>{i18n.t('maintenanceCardLabel.description')}</div>
        <div style={styles.maintenance}>{maintenance.description ? maintenance.description : ''}</div>
      </div>
      <div style={styles.maintenanceContainer}>
        <div style={styles.label}>{i18n.t('maintenanceCardLabel.value')}</div>
        <div style={styles.maintenance}>{maintenance.value ? `R$ ${numberToCurrency(maintenance.value)}` : ''}</div>
      </div>
      <div style={styles.maintenanceContainer}>
        <div style={styles.label}>{i18n.t('maintenanceCardLabel.company')}</div>
        <div style={styles.maintenance}>{maintenance.company ? maintenance.company : ''}</div>
      </div>
      <div style={styles.maintenanceContainer}>
        <div style={styles.label}>{i18n.t('maintenanceCardLabel.sendToMaintenanceDate')}</div>
        <div style={styles.maintenance}>{ !isEmpty(maintenance.sendToMaintenanceDate) ? moment(maintenance.sendToMaintenanceDate).format('DD/MM/YYYY') : '' }</div>
      </div>
      <div style={styles.maintenanceContainer}>
        <div style={styles.label}>{i18n.t('maintenanceCardLabel.returnFromMaintenanceDate')}</div>
        <div style={styles.maintenance}>{ !isEmpty(maintenance.returnFromMaintenanceDate) ? moment(maintenance.returnFromMaintenanceDate).format('DD/MM/YYYY') : '' }</div>
      </div>
      <div style={styles.maintenanceContainer}>
        <div style={styles.label}>{i18n.t('maintenanceCardLabel.warranty')}</div>
        <div style={styles.maintenance}>{ !isEmpty(maintenance.warranty) ? moment(maintenance.warranty).format('DD/MM/YYYY') : '' }</div>
      </div>
      <div style={styles.maintenanceContainer}>
        <div style={styles.label}>{i18n.t('maintenanceCardLabel.expiration')}</div>
        <div style={styles.maintenance}>{ !isEmpty(maintenance.expiration) ? moment(maintenance.expiration).format('DD/MM/YYYY') : '' }</div>
      </div>
    </Container>
  );
}

const styles = {
  container: {
    cursor: 'pointer',
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  equipmentName: {
    fontSize: '1rem',
    fontWeight: 'bold'
  },
  descriptionContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  label: {
    color: "#828282",
    fontSize: "0.8rem"
  },
  maintenanceContainer: {
    marginTop: 10
  },
  maintenance: {
    marginTop: -3
  }
}


export default withRouter(MaintenanceCard);